import api from "../api/axios"

export const getCourseSessions = (params) =>
  api.get("/course-sessions", { params }).then((r) => r.data)

export const createCourseSession = (data) =>
  api.post("/course-sessions", data).then((r) => r.data)

export const updateCourseSession = (id, data) =>
  api.put(`/course-sessions/${id}`, data).then((r) => r.data)

export const deleteCourseSession = (id) =>
  api.delete(`/course-sessions/${id}`).then((r) => r.data)
